import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import FeatherIcon from "feather-icons-react";

// import "../../clinetAssets/bootstrap-4.0.0/css/bootstrap.min.css";
// import "../../clinetAssets/css/main.css";
// //import "../../clinetAssets/css/common.css";
// import "../../clinetAssets/css/sidebar.css";
// import "../../clinetAssets/css/main-navbar.css";
// //import "../../clinetAssets/css/all-pending-candidate.css";
// import "../../clinetAssets/css/button.css";
 import "../../clinetAssets/css/header.css";
// import "../../clinetAssets/css/footer.css";
//import "../../clinetAssets/css/candidate_tab.css";
//import "../../clinetAssets/css/search.css";
//import "../../clinetAssets/css/act-feed.css";
//import "../../clinetAssets/css/modal.css";
//import "../../clinetAssets/css/tab-style-1.css";
//import "../../clinetAssets/css/status.css";
//import "../../clinetAssets/css/custom-radio.css";
//import "../../clinetAssets/css/custom-checkbox.css";
//import "../../clinetAssets/css/cstm-select.css";
//import "../../clinetAssets/css/table.css";
//import "../../clinetAssets/css/text.css";
//import "../../clinetAssets/css/accordian.css";
//import "../../clinetAssets/css/custom-modal.css";
//import "../../clinetAssets/css/form.css";
//import "../../clinetAssets/css/alerts.css";
//import "../../clinetAssets/css/react.css";
// import SearchModal from "../Modal/searchModal";
// import HelpModal from "../Modal/HelpModal";
// import NotificationModal from "../Modal/NotificationModal";

import RSPLLogo from '../../assets/img/RSPL-Logo-1.png';
import logoBlue from "../../clinetAssets/images/ibridge-logo-blue-new.svg";
import dash from "../../clinetAssets/images/dash.png";
import { getClientChange, deleteClientChange } from "../../Actions/ClientListAction";
import { useDispatch, useSelector } from "react-redux";
import { getClientLogout } from "../../Actions/clientLogoutAction";
import { useNavigate } from "react-router-dom";
// import MyProfile from "../../Screen/myProfile";
// import { getSearchFieldsData } from "../../Actions/searchAction";
import { base_url, base_url_client, CLIENT_LOGOUTURL } from "../../Constants/config";

const ClientHeader = () => {

  const [showSearchPopUp, setShowSearchPopup] = useState(false);
  const [showHelpModal, setShowHelpModal] = useState(false);
  const [showNotificationModal, setShowNotificationModal] = useState(false);
  const [name, setName] = useState('');
  const [userRole, setUserRole] = useState('');
  const [showClientSwitch,setShowClientSwitch]=useState(false);


  const storeUserData = useSelector((state) => state.user);

  const {
    userData,
    loading: loadingUser,
    error: errorUser,
  } = storeUserData;

  const autoLoginStore = useSelector((state) => state.autoLogin);
  const { autoLoginData, loadingLogin } = autoLoginStore;

  let clientId;
    let userData1 = JSON.parse(localStorage.getItem("userVerification"));
  if(userData1 && (userData1?.client_id || userData1?.bridge_client_id)){
    clientId = userData1?.client_id || userData1?.bridge_client_id;  
  }

  useEffect(() => {
    if (
      typeof autoLoginData?.status !== "undefined" &&
      autoLoginData?.status !== null
    ) {
      
     setName(autoLoginData.data.user_name);
     setUserRole(autoLoginData.data.user_role)
    }
  }, [autoLoginData, autoLoginStore]);

    // useEffect for setting state of loader value
    useEffect(() => {
      if (typeof userData !== "undefined" && userData !== null) {

        const user_name  = userData?.data?.user_name; 
       // setName(user_name);
       
      }
    }, [userData, userData?.data?.user_name]);

  let navigate = useNavigate();
  let userVerif = JSON.parse(localStorage.getItem("userVerificationCandidate"));
  const storeLogoutData = useSelector((state) => state.logout);
  const { logoutData, loading, error } = storeLogoutData;
  
  // let userName = localStorage.getItem("Name");
  
  // console.log(userName);
  // setName(userName);
  //     console.log('xys',name);
   let name1="";
  if( name!="undefined"){
    name1 = name.split(" ");
  // name1="rakesh";
  }
   console.log(name1[0]);

  useEffect(() => {
    if (typeof logoutData !== "undefined" && logoutData !== null) {
      if (logoutData.status === "success") {
        if(userRole == "EP"){
          // window.location.href = base_url_client;
          window.location.href = CLIENT_LOGOUTURL;
        }else{
          window.location.href = "login";
        }
      }
    }
  }, [storeLogoutData]);

  const dispatch = useDispatch();

  const logoutHandler = () => {
    dispatch(getClientLogout());
    localStorage.clear();
    // window.location.href="login";
    // navigate(base_url_client + "/dashboard");
    //localStorage.clear('userVerificationCandidate');
  };


  ///////////////////////////////

  const openHelpModal = () => {
    setShowHelpModal(true);
    let windowOffset=window.scrollY
    document.body.setAttribute('style',`position: fixed; top: -${windowOffset}px; left: 0; right:0;`)
    console.log(showHelpModal);
  };

  const closeHelpModal = () => {
    setShowHelpModal(false);
    // let windowOffset=window.scrollY
    // document.body.setAttribute('style','')
    // window.scrollTo(0,windowOffset)
    document.body.style.overflow='unset';
  };


  const openNotificationModal = () => {
    setShowNotificationModal(true);
    // let windowOffset=window.scrollY
    // document.body.setAttribute('style',`position: fixed; top: -${windowOffset}px; left: 0; right:0;`)
    if(typeof window != 'undefined' && window.document) {
      document.body.style.overflow = 'hidden';
    }
  };

  const closeNotificationModal = () => {
    setShowNotificationModal(false);
    let windowOffset=window.scrollY
    document.body.setAttribute('style','')
    window.scrollTo(0,windowOffset)
  };

  useEffect(()=>{
    let userData1=JSON.parse(localStorage.getItem("userVerificationCandidate"));

  if(userData1?.is_primary == 3 && userData1?.is_prepaid_client !== null){
  setShowClientSwitch(true);
  }
  },[]);

  const handleSwitch=()=>{
    let record = {};
    let item=JSON.parse(localStorage.getItem("userVerificationCandidate"));      
    record.user_id = item.user_id;
    dispatch(getClientChange(record));
    // navigate(`${base_url_client}/master`);
  }
  const storeClientChangeData = useSelector((state) => state.clientChange);
  const {
    clientChangeData,
    loading: loadingBul,
    error: errorBulk,
  } = storeClientChangeData;

  useEffect(() => {
    if (
      typeof clientChangeData?.data !== "undefined" &&
      clientChangeData?.data !== null
    ) {
        if (clientChangeData.token) {
          let item=JSON.parse(localStorage.getItem("userVerificationCandidate"));
          
           item.id=clientChangeData.token;
           item.is_prepaid_client=clientChangeData.data.is_prepaid_client;
           let userName=item.user_name;

           console.log("item",item);
           localStorage.setItem("userVerificationCandidate",JSON.stringify(item));

            //  localStorage.setItem('user_name' , user_name);
            let obj = {
              data: {},
            };
            // let data = {};
            // obj.push(data);
            obj.data.id = clientChangeData.token;
              obj.data.user_name = userName;
            console.log(obj);

            dispatch({
              type: "USER_LOGIN_SUCCESS",
              payload: obj,
            });
            dispatch(deleteClientChange());
            window.location.assign(`${base_url_client}/master`);
          }
        }
  }, [clientChangeData, storeClientChangeData]);

  return (
    <header className="client">
      <nav class="navbar navbar-expand-lg navbar-light pt-0 pb-0 cstm-navbar-2 ">
        <div class="logo">
          
        <a href={base_url_client + "/dashboard"} title="Home">
            
            <img src={logoBlue} style={{marginTop: clientId == "467104" ? 0 : 0}}/>
            {clientId == "467104" &&
                <img src={RSPLLogo} className="ml-2" style={{height: 55, marginTop: 0}} />
            }
          </a>
        </div>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto h-60">
            <li class="nav-item" >
              {/* onClick="showSearchModal()" */}
              <a href={base_url_client + "/dashboard"} title="Search">
                  <FeatherIcon icon="search" />
              </a>
            </li>
            <li title="Help" >
              <a href={base_url_client + "/dashboard"}>
             
                <FeatherIcon icon="life-buoy" />
              </a>
            </li>
            {
              (userData?.data?.is_prepaid_client==1 || userVerif?.is_prepaid_client == 1)&&(
                <li title="Wallet " id="add_wallet" 
                // onClick={()=>{navigate('../prepaid-wallet')}}
                >
                <a href={base_url_client + "/prepaid-wallet"} style={{cursor:'pointer'}}>
                <i class="fa-solid fa-wallet"></i>
                  {/* <FeatherIcon icon="life-buoy" /> */}
                </a>
              </li>
            )}
            {/* <li onClick={openNotificationModal}>
              <a title="Notification" >
                <i>
                  <FeatherIcon icon="bell" />
                </i>
              </a>
            </li> */}
            {/* <li class="nav-item">
            <a href="#"><i><FeatherIcon icon="credit-card" /></i></a>
            </li> */}
            <li class="nav-item dropdown main-navbar">
              <a
                class="nav-link dropdown-toggle p-0"
                href="#"
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i data-feather="user" class="mr-2" title="Profile">
                  <FeatherIcon icon="user" />
                </i>
                <span class="mr-1" title="Profile">Hi {name1[0]}</span>

                <i data-feather="chevron-down">
                  <FeatherIcon icon="chevron-down" className="clr-blk" />
                </i>
              </a>

             {showClientSwitch == false ? <div class="dropdown-menu profile dropdown-menu-right">
              <a class="dropdown-item mb-2" href={base_url_client + "/my-profile"}>
                  <i data-feather="user">
                    <FeatherIcon icon="user" />
                  </i>
                  <span>My Profile</span>
                </a>
                {/* <a class="dropdown-item mb-2" href="#">
                  <i data-feather="user">
                    <FeatherIcon icon="user" />
                  </i>
                  <span>My Profile</span>
                </a> */}
                <a class="dropdown-item mb-2" href={base_url_client + "/reset-password"}>
                  <i data-feather="key">
                    <FeatherIcon icon="key" />
                  </i>
                  <span>Change Password</span>
                </a>

                <a class="blue-text mb-2">
                  Company
                </a>

                <a class="dropdown-item mb-2" href="https://authbridge.com/"  target="_blank">
                  <i data-feather="flag">
                    <FeatherIcon icon="flag" />
                  </i>
                  <span>
                   
                      About AuthBridge
                   
                  </span>
                </a>
                <a class="dropdown-item mb-2" href="https://ibridge.authbridge.com/home/privacy-policy/" target="_blank">
                  <i data-feather="message-circle">
                    <FeatherIcon icon="message-circle" />
                  </i>
                  <span>
                   
                      Privacy Policy
                  
                  </span>
                </a>
                <div class="log_btn mt-1">
                    <a  target="_blank">
                  <button
                    class="btn btn-secondary red btn-block"
                    onClick={logoutHandler}
                  >
                    Logout
                  </button>
                  </a>
                </div>
              </div>:
               <div className="dropdown-menu profile">
               <div className="log_btn mt-1">
                 <button
                   style={{
                     background: "#EFF8FF",
                     border: "1px solid #EFF8FF",
                     boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                     borderRadius: "8px",
                     width: "187px",
                     color: "#184989"
                   }}
                   className="btn btn-secondary btn-block"
                   onClick={handleSwitch}
                 >
                   Switch Client
                 </button>
               </div>
               <div className="log_btn mt-1">
                 <button
                   style={{
                     background: "#EFF8FF",
                     border: "1px solid #EFF8FF",
                     boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                     borderRadius: "8px",
                     width: "187px",
                     color: "#B42318"
                   }}
                   className="btn btn-block"
                   onClick={logoutHandler}
                 >
                   Logout
                 </button>
               </div>
             </div>}
            </li>
          </ul>
        </div>
        {/* {
          showSearchPopUp &&
          <SearchModal
          showModal={showSearchPopUp}
          setShowSearchPopup={setShowSearchPopup}
          closeModal={closeModal}
          />
        }  */}


{/* <HelpModal
          showModal={showHelpModal}
          // setShowSearchPopup={setShowSearchPopup}
          closeModal={closeHelpModal}
        />

<NotificationModal
          showModal={showNotificationModal}
          // setShowSearchPopup={setShowSearchPopup}
          closeModal={closeNotificationModal}
        /> */}

      </nav>
    </header>
  );
};

export default ClientHeader;